import { render, staticRenderFns } from "./wxJqr.vue?vue&type=template&id=3c0f4394"
import script from "./wxJqr.vue?vue&type=script&lang=js"
export * from "./wxJqr.vue?vue&type=script&lang=js"
import style0 from "./wxJqr.vue?vue&type=style&index=0&id=3c0f4394&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports